
import {BRAND_PROPERTIES} from 'editec/brandsProperties.enum.js'

const toBoolean= (value)=>value ==='true'
// function that adds properties to app.config based on dynamic properties that can be used in Admin-console
export const processCustomDataProperties=(currentBrand)=>{
    if(currentBrand?.customData){
        Object.entries(currentBrand.customData).forEach(([key,value])=>{
            if(key in BRAND_PROPERTIES){
                app.config[key] = toBoolean(value)
            }
        })
    }
}
// function that checks if property is type 'truly'
export const isConfigDisabledAndNotLocal = (configKey)=>{
    return (
      !app.config[configKey] && 
      !window.location.origin.includes("localhost")
    );
  }